const DEFAULT_ROOT_FONT_SIZE_PX = 16;

/** Converts a CSS length (`px` or `rem`) to a pixel number for use in drag/resize math. Returns 0 for unsupported units (e.g. `%`) or empty values. */
export function cssLengthToPx(
  value: string | undefined,
  rootFontSizePx = DEFAULT_ROOT_FONT_SIZE_PX
): number {
  if (!value) return 0;

  const trimmed = value.trim();
  if (trimmed.endsWith('px')) {
    return parseFloat(trimmed) || 0;
  }
  if (trimmed.endsWith('rem')) {
    return (parseFloat(trimmed) || 0) * rootFontSizePx;
  }

  return 0;
}
